'use strict';
import $ = require('jquery');
import Parts                from "./class/common/parts";
import healthTable          from "./class/health/health-table";
import healthScroll         from "./class/health/health-scroll";
import recruitHero          from "./class/recruit/recruit-hero";
import recruitLine          from "./class/recruit/recruit-line";
import recruitGsap          from "./class/recruit/recruit-gsap";
$(() => {
    new Parts();
    new healthTable();
    new healthScroll();
    new recruitHero();
    new recruitLine();
    new recruitGsap();
});